//src/components/configuration/ph5/message/Selector.js
//Select messages from a list
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Popover, Tooltip, InputAdornment, TextField, Typography, Card, CardActions, CardContent } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Display from '../../display/Display';
import MessageMenu from './Menu';
//import MessageItem from './Item';


const useStyles = makeStyles((theme) => ({
    advancedCard : {
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
    headerText : {
        fontSize: '1.2rem',
        minWidth: 200,
        padding : theme.spacing(1),
        margin: 'auto'
    }
}));

export default function MessageSelector(props){
    const {width, height, items, onSelect, onDelete, isAdmin, onSave, render, label, scale, splitVertical} = props;
    const classes = useStyles();
    const [msgPop, setMsgPop] = React.useState({
        anchor: null,
        message : {}
    });
    const [search, setSearch] = React.useState(null)

    const origins = {
        vertical: 'center',
        horizontal: 'center'
    }

    const handleClick = (e, message) => {
        if(isAdmin(message)) return setMsgPop({
            anchor: e.currentTarget,
            message: message
        });
        onSelect(message);
    }

    const handleDelete = (msg) => {
        closePop();
        onDelete(msg);
    }

    const handleSelect = (e) => {
        closePop();
        onSelect(msgPop.message);
    }

    const closePop = (e) => {
        setMsgPop({
            anchor: null,
            message: msgPop.message
        });
    }

    const handleSaveMessage = (message) => {
        //update the msgpop
        setMsgPop({
            anchor : msgPop.anchor,
            message: message
        });
        return onSave(message);
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }

    const applySearch = () => {
        if(!search) return items;
        return items.filter(n => 
            n.name.toLowerCase().includes(search.toLowerCase())
            || n.description.toLowerCase().includes(search.toLowerCase())
        );
    }

    return (
        
        <Card className={classes.advancedCard}>
            <CardActions display="flex">
                <Typography className={classes.headerText}>{label ? label : 'Message Library'}</Typography>
                <TextField
                    size="small"
                    margin="none"
                    id="message-search"
                    type="search"
                    placeholder="Filter messages"
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>
                    }}
                    value={search}
                    variant="outlined"
                    onChange={handleSearch}
                    fullWidth
                />
            </CardActions>
            <CardContent className={classes.advancedContent}>
                {applySearch().map((message, i) => (
                <Tooltip key={i} title={message.name} arrow>
                <Button key={i} onClick={(e) => handleClick(e, message)}>
                    
                    <Display
                        pixel_map={render(message)}
                        width={width}
                        height={height}
                        splitVertical={splitVertical}
                        scale={scale ? scale : 1}
                    />
                </Button>
                </Tooltip>
                ))}
            </CardContent>
            
            <Popover
                id="msg_click_popover"
                open={Boolean(msgPop.anchor)}
                anchorEl={msgPop.anchor}
                onClose={closePop}
                anchorOrigin={origins}
                transformOrigin={origins}
            >
                {msgPop.message.id ? 
                (<MessageMenu
                    message={msgPop.message}
                    width={width}
                    height={height}
                    splitVertical={splitVertical}
                    onSelect={handleSelect}
                    onDelete={handleDelete}
                    onSave={handleSaveMessage}
                    render={render} />) : 
                ''}
            </Popover>
        </Card>
    )
}